import { Injectable, inject } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
  providedIn: "root",
})
export default class LoadingService {
  private spinner = inject(NgxSpinnerService);

  turnOffCanDeactive: boolean;

  start(): void {
    this.spinner.show("spinner");
  }

  stop(turnOff?: boolean): void {
    this.spinner.hide("spinner");
    this.turnOffCanDeactive = turnOff;
  }
}
